import {
  FilesPreviewGallery,
  useFilePreviewGallery,
} from '../../FilesPreviewGallery'
import { MultiValuedList } from '../../MultiValuedList'

import { FILES_VISIBLE_COUNT_DEFAULT } from './FileTableAttachments.constants'
import { filter, sortMoreItems } from './FileTableAttachments.utils'
import { Items } from './Items'
import { ListItem } from './ListItem'
import { More } from './More'
import { MoreItem } from './MoreItem'

import * as styles from './FileTableAttachments.module.css'

function FileTableAttachments({
  className = styles.FileTableAttachments,
  files,
  floatingPortalId,
  scope,
  scrollRef,
  subject,
  tooltipHintKey = 'EmailTable.MessageFilesItemTooltipHintKey',
  visibleCount = FILES_VISIBLE_COUNT_DEFAULT,
}) {
  const { activeFileIndex, handleClickFile, handleCloseFilePreview } =
    useFilePreviewGallery({
      files,
    })

  return (
    <div className={className}>
      <MultiValuedList
        Item={ListItem}
        Items={Items}
        More={More}
        MoreItem={MoreItem}
        filter={filter}
        floatingPortalId={floatingPortalId}
        itemProps={{ tooltipHintKey }}
        items={files}
        moreItemsProps={{ onClickItem: handleClickFile }}
        moreProps={{ containerRef: scrollRef }}
        sortMoreItems={sortMoreItems}
        visibleCount={visibleCount}
        onClickItem={handleClickFile}
      />
      <FilesPreviewGallery
        files={files}
        initActive={activeFileIndex}
        scope={scope}
        subject={subject}
        onClose={handleCloseFilePreview}
      />
    </div>
  )
}

export default FileTableAttachments
